import type { DeleteWizardMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteWizardDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { FrontendRouterInputs } from '../routerInputs';

type DeleteWizardMutationVariables = FrontendRouterInputs['wizard']['delete'];

export const useDeleteWizard = createMutationHook({
  name: 'deleteWizard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.wizard.delete.mutationOptions({ onSuccess }),
  mapInput: (
    variables: DeleteWizardMutationVariables
  ): DeleteWizardMutationVariables => ({
    RiskId: variables.RiskId,
  }),
  invalidate: (trpc) => [
    trpc.frontend.wizard.wizards.queryKey(),
    trpc.frontend.wizard.wizardById.queryKey(),
  ],
  mapResponse: (trpcData: { affectedRows: number }): DeleteWizardMutation => ({
    deleteWizardById: {
      __typename: 'GenericMutationOutput',
      affected_rows: trpcData.affectedRows,
    },
  }),
  graphqlDocument: DeleteWizardDocument,
  graphqlVariables: (variables: DeleteWizardMutationVariables) => variables,
  evictFields: ['wizard'],
});
